export class Role {
  constructor(params) {
    this.id = params.id;
    this.name = params.name;
  }

  multiSelectParams() {
    return { id: this.id, optionText: this.name };
  }
}

export default Role;
